import { LAST_VERSION } from "src/constants";
import storeV1, {
  actions as actionsV1,
  resolveSpeciesId as resolveSpeciesIdV1,
  decodePackedStage as decodePackedStageV1,
} from "./versions/1.0.0";

const VERSION_MAP = {
  "1.0.0": {
    store: storeV1,
    actions: actionsV1,
    resolveSpeciesId: resolveSpeciesIdV1,
    decodePackedStage: decodePackedStageV1,
  },
};

const selectedVersion = process.env.VUE_APP_CONTRACT_VERSION || LAST_VERSION;
const selected = VERSION_MAP[selectedVersion] || VERSION_MAP["1.0.0"];

export const actions = selected.actions;
export const resolveSpeciesId = selected.resolveSpeciesId;
export const decodePackedStage = selected.decodePackedStage;

export default selected.store;
